/**
 * Created by slava on 23/3/20
 */

const BaseButtonBooster = cleverapps.UI.Button.extend({
    avoidNode: "ButtonBooster",

    ctor: function (options) {
        this.booster = options.booster;
        this.styles = options.styles;

        this.content = this.getContent();
        if (this.styles.contentOff) {
            this.contentOff = this.getContent(true);
        }

        this.onChangeAmount();

        const buttonOptions = {
            onClicked: this.onPressed.bind(this),
            content: this.content,
            contentOff: this.contentOff,
            spine: options.spine,
            type: cleverapps.styles.UI.Button.Images.booster_button,
            click_effect: undefined
        };

        cleverapps.overrideStyles(buttonOptions, this.getSize());

        this._super(buttonOptions);

        this.setCascadeOpacityEnabled(true);
        this.setCascadeColorEnabled(true);

        this.onResize();

        if (this.styles.position) {
            this.setAlignment(this.styles.position);
        }

        this.booster.on("changeAmount", this.createListener(this.onChangeAmount.bind(this)), this);
        cleverapps.adsLimits.on("update", this.onChangeAmount.bind(this), this);
        cleverapps.user.on("changeHard", this.onChangeAmount.bind(this), this);

        this.booster.onToggleArrowListener = this.createListener(this.toggleArrow.bind(this));
        this.booster.onToggleTintListener = this.createListener(this.toggleTint.bind(this));
        this.booster.onExecuteListener = this.createListener(this.onExecute.bind(this));
        this.booster.onEnableListener = this.createListener(this.enable.bind(this));
        this.booster.onDisableListener = this.createListener(this.disable.bind(this));

        this.booster.on("freePrice", this.switchToFreePrice.bind(this), this);
        this.booster.on("regularPrice", this.switchToRegularPrice.bind(this), this);

        cleverapps.aims.registerTarget(`boosters${this.booster.id}`, this, {
            controls: this.getControlId(),
            flyingUnderShadow: true
        });

        this.booster.onGetView = function () {
            return this;
        }.bind(this);
    },

    onChangeAmount: function () {
        if (this.free || this.booster.inRewardAnimation) {
            return;
        }
        const currentText = this.getCurrentText();
        const currentTextOff = this.getCurrentText(true);
        const children = [this.amount, this.price, this.ads, this.amountOff, this.priceOff, this.adsOff].filter(Boolean);
        children.forEach((text) => {
            text.setVisible(text === currentText || text === currentTextOff);
        });

        this.setAmount(this.booster.getAmount());
    },

    getCurrentText: function (isOff = false) {
        const suffix = isOff ? "Off" : "";
        switch (this.booster.getState()) {
            case BaseBooster.AMOUNT_STATE: return this[`amount${suffix}`];
            case BaseBooster.PRICE_STATE: return this[`price${suffix}`];
            case BaseBooster.ADS_STATE: return this[`ads${suffix}`];
        }
    },

    setAmount: function (amount) {
        this.amount.setString(`x${amount}`);
        if (this.amountOff) {
            this.amountOff.setString(`x${amount}`);
        }
    },

    onResize: function () {
        this.baseScale = this.styles.scale[cleverapps.resolution.mode];
        this.setScale(this.baseScale);
        const size = this.getSize();
        this.resize(size.width || size, size.height);

        this.layout.setOptions(this.getLayoutOptions());
        this.layout.setAlignment(this.styles.content.layout);

        if (this.layoutOff) {
            this.layoutOff.setOptions(this.getLayoutOptions());
        }
    },

    getSize: function () {
        return this.styles.size || {
            width: this.styles.width,
            height: this.styles.height
        };
    },

    toggleArrow: function (on) {
        if (on) {
            this.pointer = PointerView.create({
                target: this
            });
        } else {
            PointerView.remove(this.pointer);
            this.pointer = undefined;
        }

        if (this.icon instanceof cleverapps.Spine) {
            this.icon.setAnimation(0, on ? "animation" : "idle", true);
        }
    },

    toggleTint: function (on) {
        this.hintOn = on;
        this.runTintAnimation();
    },

    getForceActions: function () {
        return [
            function (f) {
                this.switchToFreePrice();
                setTimeout(f, 700);
            }.bind(this),
            function (f) {
                cleverapps.focusManager.showControlsWhileFocused(this.getControlId(), true);

                cleverapps.forces.create(this, this.booster.force);
                cleverapps.forces.onceForceClosed = f;
            }.bind(this)
        ];
    },

    getControlId: function () {
        return this.booster.getControlId();
    },

    runTintAnimation: function () {
        if (this.tintRunning || !this.hintOn) {
            return;
        }

        this.tintRunning = true;
        const white = cleverapps.styles.COLORS.WHITE;
        const color = cleverapps.styles.COLORS.HINT_ALARM_COLOR || cleverapps.styles.COLORS.PLAYER_ALARM_COLOR;

        this.background.runAction(new cc.Sequence(
            new cc.TintTo(0.7, color.r, color.g, color.b),
            new cc.TintTo(0.7, white.r, white.g, white.b),
            new cc.CallFunc(() => {
                this.tintRunning = false;
                this.runTintAnimation();
            })
        ));
    },

    createIcon: function () {
        if (bundles.game.jsons.hint_icon_json) {
            const animation = new cleverapps.Spine(bundles.game.jsons.hint_icon_json);
            animation.setAnimation(0, "idle", true);
            return animation;
        }
        return new cc.Sprite(bundles.game.frames.hint_icon_png);
    },

    getLayoutOptions: function () {
        const styles = this.styles.content;
        const resolutionMode = cleverapps.resolution.mode;

        const options = [styles.margin, styles.direction, styles.reversed].map((option) => {
            if (Array.isArray(option)) {
                return option[resolutionMode];
            }
            return option;
        });

        return {
            margin: options[0],
            direction: options[1],
            reversed: options[2]
        };
    },

    getContent: function (isOff = false) {
        const content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        const options = this.getLayoutOptions();

        const price = this[isOff ? "priceOff" : "price"] = this.getPriceText(isOff);
        price.setCascadeOpacityEnabled(true);

        const textNode = this[isOff ? "textNodeOff" : "textNode"] = new cc.Node();
        textNode.setAnchorPoint(0.5, 0.5);
        textNode.setContentSize(price.getContentSize());

        const amount = this[isOff ? "amountOff" : "amount"] = this.getAmountText(isOff);

        const ads = this[isOff ? "adsOff" : "ads"] = this.getAdsText(isOff);

        const icon = this[isOff ? "iconOff" : "icon"] = this.createIcon(isOff);

        [price, amount, ads].forEach((el) => {
            textNode.addChild(el);
            el.setAlignment({ align: "center" }, { align: "center" });
        });

        const layoutKey = isOff ? "layoutOff" : "layout";
        this[layoutKey] = new cleverapps.Layout([icon, textNode], options);
        content.addChild(this[layoutKey]);

        content.setAlignment({ x: { align: "center" }, y: { align: "center" } });
        this[layoutKey].setAlignment(this.styles.content.layout);

        return content;
    },

    getPriceText: function (isOff) {
        const price = this.booster.getPrice();
        const textOptions = {
            font: cleverapps.styles.FONTS.BUTTON_BOOSTER,
            icons: {}
        };
        const text = `$$${price.amount}`;

        if (isOff) {
            textOptions.icons["$$"] = bundles.buttons_inlined_icons.frames.gold_icon_off_png;
        }

        return new TextWithIcon(text, textOptions);
    },

    getAmountText: function () {
        return cleverapps.UI.generateImageText(`x${this.booster.getAmount()}`, cleverapps.styles.FONTS.AMOUNT_BOOSTER);
    },

    getAdsText: function (isOff) {
        const textOptions = {
            font: cleverapps.styles.FONTS.BUTTON_BOOSTER,
            icons: {}
        };
        if (isOff) {
            textOptions.icons["##"] = bundles.buttons_inlined_icons.frames.ad_icon_off_png;
        }
        const free = new TextWithIcon(`## ${Messages.get("BoosterFree")}`, textOptions);
        free.fitTo(this.getFreeTextWidth());
        return free;
    },

    createFreePrice: function () {
        // eslint-disable-next-line no-restricted-syntax
        const free = cleverapps.UI.generateTTFText(Messages.get("BoosterFree"), cleverapps.styles.FONTS.BUTTON_BOOSTER);
        free.fitTo(this.getFreeTextWidth());

        free.setPosition(this.textNode.width / 2, this.textNode.height / 2);
        this.textNode.addChild(free);
        return free;
    },

    switchToFreePrice: function () {
        const currentText = this.getCurrentText();

        const free = this.free = this.createFreePrice();
        free.setOpacity(0);
        free.setVisible(false);

        currentText.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.Hide()
        ));
        free.runAction(new cc.Sequence(
            new cc.DelayTime(0.3),
            new cc.Show(),
            new cc.FadeIn(0.3)
        ));
    },

    getFreeTextWidth: function () {
        const styles = this.styles.content.freeBlock;

        return styles.textWidth;
    },

    switchToRegularPrice: function () {
        this.free.runAction(new cc.Sequence(
            new cc.FadeOut(0.3),
            new cc.RemoveSelf(),
            new cc.CallFunc(() => {
                delete this.free;
                this.onChangeAmount();
                const currentText = this.getCurrentText();
                currentText.runAction(new cc.Sequence(
                    new cc.Show(),
                    new cc.FadeIn(0.3)
                ));
            })
        ));
    },

    onPressed: function () {
        cleverapps.effects.fire("ui.booster.press");

        cleverapps.focusManager.display({
            focus: "ExecuteButtonBooster",
            stack: true,
            keepControls: true,
            action: function (f) {
                this.booster.onPressed(f);
            }.bind(this)
        });
    },

    onExecute: function () {
        if (this.icon instanceof cleverapps.Spine && cleverapps.config.name === "crocword") {
            this.icon.setAnimationAndIdleAfter("hint", "idle");
        }

        cleverapps.effects.fire(this.booster.executeEffect);
    },

    getForceImportantNodes: function () {
        return [this.layout].concat(this.getForceHighlights());
    },

    getForceHighlights: function () {
        return [];
    }
});

cleverapps.styles.FONTS = cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    BUTTON_BOOSTER: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    },

    AMOUNT_BOOSTER: {
        size: 45,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.IMAGE_FONT_STROKE
    }
});

cleverapps.styles.ButtonBooster = {
    contentOff: false,
    width: 150,
    height: 130,
    zOrder: 0,

    position: [
        { x: { align: "center", dx: 0 }, y: { align: "bottom", dy: 200 } },
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 360 } },
        { x: { align: "right", dx: -10 }, y: { align: "bottom", dy: 360 } }
    ],

    scale: [0.8, 1, 1],

    content: {
        margin: 20,
        direction: cleverapps.UI.HORIZONTAL,
        layout: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 0 }
        },
        freeBlock: {
            textWidth: 120
        }
    }
};
